module.exports = __webpack_public_path__ + "img/selected0-min.3beca7d6.png";